module.exports = __webpack_public_path__ + "img/07.a0abfdb3.png";